import { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Input, Row, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import { getEnquiries } from '../../store/enquirySlice';
import { service } from '../../shared/_services/api_service';
import SweetAlert from 'sweetalert2';

const EnquiryTable = () => {
  const storeVar = useSelector((state) => state.enquiry);
  const dispatch = useDispatch();
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 500;
  const [testSeriesNames, setTestSeriesNames] = useState([]);
  const [formVar, setFormVar] = useState({
    keyword: '',
    targetExam: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
  });

  useEffect(() => {
    dispatch(getEnquiries(formVar.limit, formVar.offset, formVar.keyword, formVar.targetExam));
    service.getTestSeriesNames()
      .then((res) => {
        if (res.data && Array.isArray(res.data.result)) {
          setTestSeriesNames(res.data.result);
        }
      })
      .catch((err) => console.error("Error fetching test series names:", err));
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1);
    setFormVar((prev) => ({
      ...prev,
      currentPage: page,
      offset: offset,
    }));
    dispatch(getEnquiries(formVar.limit, offset, formVar.keyword, formVar.targetExam));
  };

  const searchState = (e) => {
    const val = e.target.value;
    setFormVar((prev) => ({ ...prev, keyword: val }));
    searchWithDelay(val, formVar.targetExam);
  };

  const handleTargetExamChange = (e) => {
    const val = e.target.value;
    setFormVar((prev) => ({ ...prev, targetExam: val, currentPage: 1, offset: 0 }));
    dispatch(getEnquiries(formVar.limit, 0, formVar.keyword, val));
  };

  const searchWithDelay = (keyword, targetExam) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      setFormVar((prev) => ({ ...prev, currentPage: 1, offset: 0 }));
      dispatch(getEnquiries(formVar.limit, 0, keyword, targetExam));
    }, typingDelay);
    setTypingTimer(timer);
  };

  const exportToCSV = async () => {
    try {
      const response = await service.exportEnquiriesCSV(formVar.keyword, formVar.targetExam);
      const csvContent = response?.data;

      if (!csvContent) {
        SweetAlert.fire({
          icon: 'info',
          title: 'No Data',
          text: 'No data returned from server.'
        });
        return;
      }

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `enquiries_list_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting enquiries to CSV:', error);
      SweetAlert.fire({
        icon: 'error',
        title: 'Export Failed',
        text: 'Failed to export enquiries CSV.'
      });
    }
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row className='align-items-center g-2'>
              <Col md='4'>
                <Input
                  className='form-control form-control-inverse btn-square'
                  type='text'
                  placeholder='Search by Name, Email, Phone, Exam, Message...'
                  value={formVar.keyword}
                  onChange={searchState}
                />
              </Col>
              <Col md='4'>
                <Input
                  type='select'
                  className='form-control form-control-inverse btn-square'
                  value={formVar.targetExam}
                  onChange={handleTargetExamChange}
                >
                  <option value=''>All Target Exams</option>
                  {testSeriesNames.map((name, index) => (
                    <option key={index} value={name}>{name}</option>
                  ))}
                </Input>
              </Col>
              <Col md='4' className='text-end d-flex align-items-center justify-content-end gap-2'>
                <span className='text-muted'>Total Enquiries: {storeVar.totalEnquiry || 0}</span>
                <Button color='primary' className='btn-square btn-sm' onClick={exportToCSV}>
                  Export CSV
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Full Name</th>
                  <th scope='col'>Email</th>
                  <th scope='col'>Phone Number</th>
                  <th scope='col'>Target Exam</th>
                  <th scope='col'>Message</th>
                  <th scope='col'>Date</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.enquiryData?.map((item, index) => (
                  <tr key={item._id || index}>
                    <th scope='row'>{formVar.offset + index + 1}</th>
                    <td>{item.fullName}</td>
                    <td>{item.email || 'N/A'}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{item.targetExam}</td>
                    <td>{item.message}</td>
                    <td>{item.createdAt ? new Date(item.createdAt).toLocaleString() : 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {(!storeVar.enquiryData || storeVar.enquiryData.length === 0) && (
            <Empty />
          )}
        </Card>
        {storeVar.totalEnquiry > 0 && (
          <Pagination
            currentPage={formVar.currentPage}
            totalItem={storeVar.totalEnquiry}
            itemsPerPage={formVar.limit}
            showEllipsisAfter={true}
            visiblePageCount={3}
            onPageChange={pageChange}
          />
        )}
      </Col>
    </Fragment>
  );
};

export default EnquiryTable;
